module.exports = "<svg viewBox=\"0 0 32 32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M4 8H16C20.4183 8 24 11.5817 24 16V28\" stroke=\"currentColor\" stroke-linecap=\"round\"></path><path d=\"M10 14H14C16.2091 14 18 15.7909 18 18V28\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\"></path><path d=\"M21 25L18.3536 27.6464C18.1583 27.8417 17.8417 27.8417 17.6464 27.6464L15 25\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\"></path><circle cx=\"7\" cy=\"14\" r=\"3\" stroke=\"currentColor\" stroke-width=\"1.5\"></circle></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/plugin/inside.svg
// module id = 1oK4
// module chunks = 1